module.exports = __webpack_public_path__ + "static/media/006.eeeff181.jpg";